<template>
  <div class="garment-lightbox">
    <div class="header p-4 absolute w-full flex items-center justify-center">
      <div class="close absolute" @click="$emit('close')">
        <CloseIcon class="close-icon" />
      </div>
      <div class="name">{{ name }}</div>
    </div>
    <div class="content">
      <iframe class="w-full h-full" :src="`${link}?embed=1`" frameborder="0" allowfullscreen />
    </div>
    <div class="footer absolute w-full" />
  </div>
</template>
<script>
import CloseIcon from '@/components/common/svg/Close.vue';

export default {
  props: {
    link: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
  },
  components: { CloseIcon },
};
</script>
<style lang="scss" scoped>
$header-height: 62px;
$footer-height: 48px;

.garment-lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  z-index: 1;

  .header {
    top: 0;
    left: 0;
    height: $header-height;

    .close {
      top: 16px;
      left: 16px;
      transform: translateY(50%);

      .close-icon {
        color: var(--primary-text);
      }
    }

    .name {
      font-family: Poppins;
      font-size: 16px;
      font-weight: 700;
    }
  }

  .content {
    height: calc(100% - #{$header-height} - #{$footer-height});
    background-color: #fff;
    margin-top: $header-height;
  }

  .footer {
    height: $footer-height;
    bottom: 0;
    left: 0;
  }
}
</style>
